import { makeStyles } from '@material-ui/core/styles';
import { useParams } from 'react-router-dom';
import { Container } from '@material-ui/core';
import { useQuery } from '@apollo/client';

import { REPORT } from '../../graphql/query/reports';

import ReportDescription from '../../components/report-description';
import ReportWorkspace from '../../components/report-workspace';
import Loader from '../../components/common/loader';

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const Report = () => {
  const classes = useStyles();
  const { id } = useParams();

  const { data, loading } = useQuery(REPORT, { variables: { id } });
  const report = data?.report;

  const renderDescription = report && <ReportDescription report={report} />;

  const renderWorkspace = report && <ReportWorkspace report={report} />;

  return (
    <Container maxWidth="lg" className={classes.container}>
      {renderDescription}
      {renderWorkspace}
      <Loader show={!data || loading} absolute transparentBackground />
    </Container>
  );
};

export default Report;
